export default __webpack_public_path__ + "static/media/XEMP-18.2af178f8.jpg";